import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger,} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {AbstractDataServiceV2} from '../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {SubscriptionModel} from '../../../api/entity/subscription.model';
import {SubscriptionConverter} from '../../../api/entity/converter/subscription.converter';
import {CustomizeHttpUrlGenerator} from '../../../../../store/core/url/customizeHttpUrlGenerator';

@Injectable({
    providedIn: 'root'
})
export class SubscriptionDataService extends AbstractDataServiceV2<SubscriptionModel, SubscriptionConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator, logger: Logger, config: DefaultDataServiceConfig,
                converter: SubscriptionConverter) {
        super('Subscription', http, httpUrlGenerator, logger, config, converter);
    }
}
